<template>
  <div class="saveprice secondary_title" >
    {{$t('home.save')}}
    <br />
    <span v-if="this.$store.state.pricetype=='CNY'">CN</span>
    {{`${getSymbolFromCurrency(this.$store.state.pricetype)} ${computePrice(saveprice)}`}}

  </div>
</template>
<script>
import getSymbolFromCurrency from "currency-symbol-map";
export default {
  props: ["saveprice"],
  data() {
    return {
      symbol: {
        AUTO: "$",
        AUD: "$",
        CAD: "$",
        CNY: "CN ￥",
        EUR: "€",
        GBP: "£",
        JPY: "￥",
        NZD: "$",
        USD: "$",
      },
      getSymbolFromCurrency: "",
    };
  },
  beforeMount() {
    this.getSymbolFromCurrency = getSymbolFromCurrency;
  },
};
</script>
<style scoped lang='scss'>
.saveprice {
  position: absolute;
  border-radius: 28px;
  border: 1px solid #990000;
  color: #990000;
  padding: 6px 11px;
  top: -13px;
  left: 0;
  font-size: 14px;
  z-index: 99;
}
</style>